import styled, { keyframes } from 'styled-components'

export interface SkeletonRowsProps {
  columnCount: number
  rowCount?: number
}

const WIDTHS = ['40%', '70%', '55%', '60%', '45%', '65%', '50%', '35%']

export const SkeletonRows = ({ columnCount, rowCount = 8 }: SkeletonRowsProps) => (
  <>
    {Array.from({ length: rowCount }).map((_, r) => (
      <tr key={r}>
        {Array.from({ length: columnCount }).map((__, c) => (
          <Cell key={c}>
            <Bar style={{ width: WIDTHS[(r + c) % WIDTHS.length] }} />
          </Cell>
        ))}
      </tr>
    ))}
  </>
)

export default SkeletonRows

const shimmer = keyframes`
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
`

const Cell = styled.td`
  padding: 0 16px;
  height: 52px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.line2};
`

const Bar = styled.span`
  display: block;
  height: 12px;
  border-radius: ${({ theme }) => theme.radii.pill};
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.line2} 25%,
    ${({ theme }) => theme.colors.line} 37%,
    ${({ theme }) => theme.colors.line2} 63%
  );
  background-size: 400% 100%;
  animation: ${shimmer} 1.4s ease infinite;
`
